export default __webpack_public_path__ + "static/cut-c-b3107d3b95be2f5912ccde3d2705a65b.png";